import * as element from '../util/element';

export function removeEl(item) {
  if (item && item.el) {
    element.removeChild(item.el.element)
    item.el = null;
  }
}



// WEBPACK FOOTER //
// ./src/chart/outer/util.js